import "./NewMultiItemRequirementDataField.less";

import { Button, Modal, Spin } from "antd";
import React from "react";

import { DataField, StringDataField } from "lib/data/model";
import { DataFieldTemplate } from "lib/data/model";
import { MultipleItemRequirement, RequirementItem } from "lib/data/model";
import { IconType } from "lib/data/model/dictionaries/IconTypes";
import { Requiredness } from "lib/data/model/enumerations";

import { MiniTemplateCard } from "components/general/TemplateCard";
import { TransitionRoute } from "components/general/TransitionRoute";
import { MultipleItemConfiguration } from "../../TemplateHierarchy/components/MultipleItemConfiguration";

interface INewMultiItemRequirementDataFieldProps {
	addNewMultiItemRequirement(multipleItemRequirement: MultipleItemRequirement<DataFieldTemplate>, callback: Function): void;
	visible: boolean;
	closeModal(): void;
	waitingForUpdate: boolean;
	dataFieldTypes: DataField[];
	showConfig?: boolean;
}
interface INewMultiItemRequirementDataFieldState {
	dataFieldTypes: DataField[];
	selectedDataTypes: DataField[];
	selectingTemplates: boolean;
}

export class NewMultiItemRequirementDataField extends React.Component<INewMultiItemRequirementDataFieldProps, INewMultiItemRequirementDataFieldState> {

	constructor(props: INewMultiItemRequirementDataFieldProps) {
		super(props);
		this.state = {
			dataFieldTypes: this.props.dataFieldTypes,
			selectedDataTypes: [],
			selectingTemplates: props.showConfig ? !props.showConfig : true
		};
	}
	public multipleItemRequirement?: MultipleItemRequirement<DataFieldTemplate>;
	componentWillMount() {
		this.setState({ dataFieldTypes: this.props.dataFieldTypes, selectedDataTypes: [] });
	}
	componentWillReceiveProps(nextProps: INewMultiItemRequirementDataFieldProps) {
		this.setState({ dataFieldTypes: nextProps.dataFieldTypes, selectedDataTypes: [], selectingTemplates: nextProps.showConfig ? !nextProps.showConfig : true });
	}
	addDataTemplateFromSelected = (dataField: DataField) => {
		const selectedDataTypes = [...this.state.selectedDataTypes];
		selectedDataTypes.push(dataField);
		this.setState({ selectedDataTypes });
	}
	removeDataTemplateFromSelected = (index: number) => {
		const selectedDataTypes = this.state.selectedDataTypes.filter((currentDataField, key) => key != index);
		this.setState({ selectedDataTypes });
	}
	createMultiItemRequirement = (dataFields: DataField[], fulfillmentCount: number = 0, isRepeatable: boolean = false, requiredness: Requiredness = Requiredness.OPTIONAL) => {
		// Create a new MultiItem Requirement
		const multipleItemRequirement: MultipleItemRequirement<DataFieldTemplate> = new MultipleItemRequirement("DataFieldTemplate");
		multipleItemRequirement.fulfillmentCount = fulfillmentCount;
		multipleItemRequirement.requiredness = requiredness;
		multipleItemRequirement.items = [];
		// loop through the data fields to setup the multiItem
		dataFields.forEach((dataField: DataField, index: number) => {
			// Create a new dataFieldTemplate
			const dataFieldTemplate: DataFieldTemplate = new DataFieldTemplate();
			// Create a new Requirement Item
			const requirementItem: RequirementItem<DataFieldTemplate> = new RequirementItem("DataFieldTemplate");
			dataFieldTemplate.name = dataField.name;
			dataFieldTemplate.stringAppendage = "";
			dataFieldTemplate.stringPrefix = "";
			requirementItem.id = 0;
			requirementItem.owningRequirement = multipleItemRequirement;
			// Add data Field to Data Field Template
			dataFieldTemplate.field = dataField;
			// Add data Field Template to Item
			requirementItem.item = dataFieldTemplate;
			// Add Item to Requirement
			multipleItemRequirement.items.push(requirementItem);
		});
		this.multipleItemRequirement = multipleItemRequirement;
	}
	switchToConfiguration = () => {
		this.setState({ selectingTemplates: false });
		this.createMultiItemRequirement(this.state.selectedDataTypes);
	}
	switchToSelection = () => {
		this.setState({ selectingTemplates: true });
		this.multipleItemRequirement = undefined;
	}
	getFooterButtons = () => {
		if (this.state.selectingTemplates) {
			return [<Button type="primary" icon="right" onClick={this.switchToConfiguration}>Next</Button>];
		}
		return [<Button type="default" icon="left" onClick={this.switchToSelection}>Back</Button>, <Button type="primary" onClick={this.commitMultiItemRequirement}>Save</Button>]

	}
	updateMultiItemRequirement = () => {
		this.forceUpdate();
	}

	commitMultiItemRequirement = () => {
		if (this.multipleItemRequirement) {
			this.props.addNewMultiItemRequirement(this.multipleItemRequirement, () => {
				this.setState({ selectingTemplates: false });
			});
		}
	}

	render() {
		return (
			<Modal footer={this.getFooterButtons()} visible={this.props.visible}
				onCancel={this.props.closeModal}
				className="NewMultiItemRequirementDataField">
				{this.props.waitingForUpdate ?
					<Spin />
					:
					<div>
						<TransitionRoute on={this.state.selectingTemplates} case={true}>

							<div className="generic-template-selector">
								Options:
                        < hr style={{ width: "100%" }} />
								<div className="template-selector-group">
									{this.state.dataFieldTypes.map((dataField, key) =>
										<MiniTemplateCard
											onClick={() => this.addDataTemplateFromSelected(dataField)}
											key={key}
											className={"new-template-mini-cards"}
											title={dataField.name}
											iconType={IconType.get(StringDataField.$type)} />)}
								</div>
								<div className="template-selector-group">
									Selected:
                        < hr style={{ width: "100%" }} />
									{this.state.selectedDataTypes.map((dataField, key) =>
										<MiniTemplateCard
											onClick={() => this.removeDataTemplateFromSelected(key)}
											key={key}
											className={"new-template-mini-cards"}
											title={dataField.name}
											iconType={IconType.get(StringDataField.$type)} />)}
								</div>
							</div>
						</TransitionRoute>
						<TransitionRoute on={this.state.selectingTemplates} case={false}>
							<div className="configuration-screen">
								<MultipleItemConfiguration updateMultiItemRequirement={this.updateMultiItemRequirement} multipleItemRequirement={this.multipleItemRequirement} />
							</div>
						</TransitionRoute>
					</div>
				}
			</Modal>
		);
	}
}
